import { useEffect, useMemo, useState } from "react";

const APE_COUNT = 12;
const ROTATE_MS = 4_000;

export default function ApeCarousel() {
  const previews = useMemo(
    () => Array.from({ length: APE_COUNT }, (_, index) => `/reference-apes/${String(index + 1).padStart(2, "0")}.png`),
    []
  );
  const [activeIndex, setActiveIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const timer = window.setInterval(() => {
      setActiveIndex((value) => (value + 1) % previews.length);
    }, ROTATE_MS);
    return () => window.clearInterval(timer);
  }, [paused, previews.length]);

  const activeSrc = previews[activeIndex];

  return (
    <div
      className="hero-ape-preview hero-ape-preview--carousel"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onFocus={() => setPaused(true)}
      onBlur={() => setPaused(false)}
    >
      <div className="ape-card-stack" aria-hidden="true" />
      <div className="ape-card" tabIndex={0} aria-label="CODE APE reference style preview carousel">
        {previews.map((src, index) => (
          <img
            key={src}
            className={`ape-card__image${index === activeIndex ? " active" : ""}`}
            src={src}
            alt={`CODE APE reference style preview ${String(index + 1).padStart(2, "0")}`}
            loading={index === 0 ? "eager" : "lazy"}
            aria-hidden={index === activeIndex ? undefined : true}
          />
        ))}
        <div className="ape-badge">REFERENCE STYLE</div>
      </div>
      <div className="ape-carousel__controls" aria-label="Reference preview selector">
        {previews.map((src, index) => (
          <button
            key={src}
            type="button"
            className={index === activeIndex ? "active" : ""}
            onClick={() => setActiveIndex(index)}
            aria-label={`Show staging reference preview ${index + 1}`}
          />
        ))}
      </div>
      <p className="text-sm text-muted ape-carousel__note">
        Reference style previews. Production minting starts with the recommended Codex flow or any compatible agent; every Ape is bound to one wallet and hash-checked before mint.
      </p>
    </div>
  );
}
